import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class BiBankResponsecodeFilter extends Component {
    state = {
        BiBankResponsecodeFilterLists:[],
        BiBankResponsecodeFilterValue: '',
        isBiBankResponsecodeFilterLoading: true
    };
    componentDidMount(){
        this.getBiBankResponsecodeFilter(this.props.start_date,this.props.end_date);
    }
    restBiBankResponsecodeFilterFilter() {
        this.setState({
            BiBankResponsecodeFilterValue: [],
        })
    }
    getBiBankResponsecodeFilter(start_date, end_date){
        this.setState({
        BiBankResponsecodeFilterLists:[],
        BiBankResponsecodeFilterValue: [],
        isBiBankResponsecodeFilterLoading: true
        })
        axios.get(config.get('API_URL')+'/filters/get_bi_bank_responsecode/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                start_date: start_date,
                end_date: end_date
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((tender_mode, index) => {
                    this.state.BiBankResponsecodeFilterLists.push({value: tender_mode.bi_bank_responsecode, label: tender_mode.bi_bank_responsecode})
                });
            }
            this.setState({
                isBiBankResponsecodeFilterLoading: false
            })
        });

    }


    changeBiBankResponsecodeFilter(optionSelected){
        let value='';
        let tenderArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenderArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                tenderArray.push(ids.value)
                var index = this.state.BiBankResponsecodeFilterLists.findIndex(obj => obj.value==ids.value);
                this.state.BiBankResponsecodeFilterLists.move(index,0).join(',');
            });
        }
        this.props.onSelectBiBankResponsecodeFilter(optionSelected, tenderArray);
        this.setState({
            BiBankResponsecodeFilterValue:optionSelected,
        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="tender_mode"
                isMulti
                value={this.state.BiBankResponsecodeFilterValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeBiBankResponsecodeFilter.bind(this)}
                options={this.state.BiBankResponsecodeFilterLists}
                placeholderButtonLabel="Select [Bi Bank Response code]"
                isLoading={this.state.isBiBankResponsecodeFilterLoading}
            />
        );

    }
}
export default BiBankResponsecodeFilter;